const Authentication = () => import('@/views/Authentication')

export default [
  {
    path: '/authentication',
    component: Authentication,
    meta: { requireAuth: true }
  }
]
